import { render, staticRenderFns } from "./DetalleActivo.vue?vue&type=template&id=676d491e&"
import script from "./DetalleActivo.vue?vue&type=script&lang=js&"
export * from "./DetalleActivo.vue?vue&type=script&lang=js&"
import style0 from "./DetalleActivo.vue?vue&type=style&index=0&id=676d491e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports